module.exports = __webpack_public_path__ + "img/brief_introduction_Image.30467dc9.png";